<script setup>
import { Heading } from "~/components/clarity-ui/Heading";
import { Paragraph } from "~/components/clarity-ui/Paragraph";
import NewsletterBenefits from "~/templates/components/shop/product/NewsletterBenefits.vue";
import { hasNodes } from "~/utils/helper/magnolia";

defineProps(["headline", "subline", "benefits"]);
</script>

<template>
  <div class="editmode-info-box flex flex-col">
    <Heading v-if="headline?.text" class="mb-4" color="blue" :tag="headline?.tag ?? 'h2'">
      {{ headline?.text }}
    </Heading>
    <Paragraph v-if="subline" class="mb-6">
      {{ subline }}
    </Paragraph>
    <NewsletterBenefits v-if="hasNodes(benefits)" :benefits="benefits" />
    <slot />
  </div>
</template>
